import api from './index';

const AUTO_EMAIL_API = '/notifications/auto-responses/';

// Cache for auto-email responses (10 minutes)
const CACHE_KEY = 'auto_email_responses';
const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

const autoEmailResponseAPI = {
  // Get all auto-email response rules
  getAll: async () => {
    try {
      // Check cache first
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_DURATION) {
          return { ...data, cached: true };
        }
      }

      const response = await api.get(AUTO_EMAIL_API);
      
      // Cache the results
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        data: response.data,
        timestamp: Date.now()
      }));
      
      return response.data;
    } catch (error) {
      console.error('Error fetching auto-email responses:', error);
      throw error;
    }
  },

  // Get single auto-email response rule
  getById: async (id) => {
    try {
      const response = await api.get(`${AUTO_EMAIL_API}${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching auto-email response ${id}:`, error);
      throw error;
    }
  },

  // Create new auto-email response rule
  create: async (data) => {
    try {
      const response = await api.post(AUTO_EMAIL_API, data);
      
      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      
      return response.data;
    } catch (error) {
      console.error('Error creating auto-email response:', error);
      throw error;
    }
  },

  // Update auto-email response rule
  update: async (id, data) => {
    try {
      const response = await api.put(`${AUTO_EMAIL_API}${id}/`, data);
      
      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      
      return response.data;
    } catch (error) {
      console.error(`Error updating auto-email response ${id}:`, error);
      throw error;
    }
  },

  // Delete auto-email response rule
  delete: async (id) => {
    try {
      const response = await api.delete(`${AUTO_EMAIL_API}${id}/`);
      
      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      
      return response.data;
    } catch (error) {
      console.error(`Error deleting auto-email response ${id}:`, error);
      throw error;
    }
  },

  // Toggle active/inactive status
  toggle: async (id) => {
    try {
      const response = await api.post(`${AUTO_EMAIL_API}${id}/toggle/`);
      
      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      
      return response.data;
    } catch (error) {
      console.error(`Error toggling auto-email response ${id}:`, error);
      throw error;
    }
  },

  // Get statistics
  getStats: async () => {
    try {
      const response = await api.get(`${AUTO_EMAIL_API}stats/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching auto-email response stats:', error);
      throw error;
    }
  },

  // Clear cache manually
  clearCache: () => {
    sessionStorage.removeItem(CACHE_KEY);
  }
};

export default autoEmailResponseAPI;

